// extracted by mini-css-extract-plugin
module.exports = {"surveys":"Survey_surveys__1qxcc","surveys__title":"Survey_surveys__title__2o8wj","surveys__content":"Survey_surveys__content__2btSn"};